
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AppCopyText extends Vue {
  @Prop({
    default: "",
  })
  public readonly value!: string;

  public onCopy(): void {
    navigator.clipboard.writeText(this.value);
    this.$notify({
      text: "Copied to clipboard",
      type: "info",
      duration: 300,
    });
  }
}
